<template>
  <div class="main">
    <PageHeader class="header" />
    <AppFooter class="mainfooter" />
    <div class="mainBody">
      <v-card class="card0">
        <v-card-title class="color">Customer Services</v-card-title>
        <div class="service">
          <v-card flat class="card1 whatsapp">
            <div>
              <img
                src="../assets/whatsapp.png"
                alt="teller logo"
                width="55"
                height="55"
              />
            </div>
            <v-card-title>Chat us on WhatsApp</v-card-title>
            <p>+234 8188964415</p>
            <p>+234 8169602155</p>
          </v-card>
          <v-card flat class="card1 email">
            <div>
              <img
                src="../assets/mail.png"
                alt="teller logo"
                width="40"
                height="30"
              />
            </div>
            <v-card-title>Email us</v-card-title>
            <p>help@teller.ng</p>
          </v-card>
          <v-card flat class="card1 phone">
            <div>
              <img
                src="../assets/phone2.png"
                alt="teller logo"
                width="38"
                height="30"
              />
            </div>
            <v-card-title>Call us on Phone</v-card-title>

            <p>+234 8169602155</p>
            <p>+234 8188964415</p>
          </v-card>
        </div>
      </v-card>
    </div>
  </div>
</template>
<script>
import PageHeader from "../components/Header";
import AppFooter from "../components/AppFooter";
export default {
  metaInfo: {
    title: "Teller/Contact",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "Teller.ng",
        content:
          "Teller.ng provides online payment settlement system which allows instant money transfer, bill payment, and airtime purchases. It’s safe, reliable and most importantly, hassle-free.Teller helps you to pay your electricity, cable, internet and other bills with ease.  For convenient airtime recharge, funds transfer, bills payments. Making your everyday payment simple, safe and secure.",
      },
    ],
  },
  components: {
    PageHeader,
    AppFooter,
  },
  data: () => ({}),
  methods: {
    navigate(to) {
      this.$router.push({ name: to });
    },
  },
};
</script>

<style scoped>
.main {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-auto-rows: minmax(50px, auto);
  margin: 0 auto;
  padding: 0px;
  grid-template-areas:
    "header header header header"
    "mainBody mainBody mainBody mainBody"
    "mainfooter mainfooter mainfooter mainfooter";
  width: 100%;
}

.header {
  grid-area: header;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 40px;
}
.mainBody {
  grid-area: mainBody;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: url("../assets/Bg.png");
  background-size: cover;
}
.mainBodytwo {
  grid-area: mainBodytwo;
  display: flex;
  justify-content: center;
  align-items: center;
}
.card {
  border-radius: 10px;
  padding: 30px;
}
.ForgotPin {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}
.ForgotPin small {
  color: #283a90;
  cursor: pointer;
}
.nextBtn {
  background-color: #ad1684 !important;
  border-radius: 10px;
}
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.login p {
  color: #ad1684;
}
.titleB {
  color: #ad1684 !important;
}
.card0 {
  padding: 30px;
  min-height: 500px;
  margin: 50px;
  border-radius: 15px !important;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  box-shadow: 0 16px 50px 0 rgba(189, 36, 39, 0.11);
  background-color: #ffffff;
}
.service {
  display: flex;
  flex-wrap: wrap;
}
.card0 h4 {
  margin: 20px;
}
.card1 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 300px;
  height: 300px;
  margin: 10px;
  border-radius: 20px;
}

.card1 h5 {
  margin-top: 5px;
  color: black;
}
.whatsapp {
  background-color: rgba(67, 197, 83, 0.24);
}
.email {
  background-color: rgba(213, 75, 61, 0.24);
}
.phone {
  background-color: rgba(0, 108, 162, 0.24);
}
.color {
  color: #ad1684;
  margin-bottom: 40px;
}
@media only screen and (max-width: 1024px) {
  .main {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-auto-rows: minmax(50px, auto);
    margin: 10 auto;
    padding: 10px;
    grid-template-areas:
      "header header header header"
      "mainBody mainBody mainBody mainBody"
      "mainBodytwo mainBodytwo mainBodytwo mainBodytwo"
      "mainfooter mainfooter mainfooter mainfooter";
  }
  .profileHeader {
    border-top-left-radius: 0px;
  }
  .mainBody {
    border-bottom-left-radius: 0px;
  }
}
</style>
